<!--
  AI:
  Status: 'in progress'
  Type: Component
  SubType: ProtectedComponent
  Reason: Eingangsfreigabe (P3). Global open-drafts list (no Gesellschaft pre-selection) with bulk
          select-all + Freigeben/Ablehnen, plus a Fiori-style master-detail grid: clicking a draft's
          Kontoauszug-Nr opens the cn.CommissionStatement detail OBC in a right-side panel. Mirrors the
          BmPaymentReconciliationAccountsComponent grid/master-detail layout.
-->
@if (initialized) {
    <div class="cn-import-review">

        <div class="grid">

            <!-- ===================== LINKS: ENTWÜRFE-LISTE + AKTIONEN ===================== -->
            <div [class]="detailOpen ? 'col-12 md:col-5' : 'col-12'">
                <div class="surface-0 border-1 surface-border border-round p-3">

                    <div class="text-lg font-medium mb-3">Eingangsfreigabe</div>

                    <!-- ----- AKTIONEN + ERGEBNIS-FEEDBACK ----- -->
                    <div class="flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                        <div class="flex align-items-center gap-3 flex-wrap">
                            <span class="text-sm text-600">
                                {{ selectedDrafts.length | number:'1.0-0':'de' }} ausgewählt
                            </span>
                            @if (approveResultMessage) {
                                <span class="text-sm font-medium text-green-600">
                                    <i class="fa-regular fa-circle-check mr-1"></i>{{ approveResultMessage }}
                                </span>
                            }
                            @if (rejectResultMessage) {
                                <span class="text-sm font-medium text-600">
                                    <i class="fa-regular fa-circle-xmark mr-1"></i>{{ rejectResultMessage }}
                                </span>
                            }
                        </div>
                        <div class="flex align-items-center gap-2 flex-wrap">
                            <p-button label="Ablehnen"
                                      icon="fa-regular fa-xmark"
                                      severity="secondary"
                                      size="small"
                                      [outlined]="true"
                                      [disabled]="!hasSelection || actionBusy"
                                      (onClick)="openRejectDialog()">
                            </p-button>
                            <p-button label="Freigeben"
                                      icon="fa-regular fa-check"
                                      severity="success"
                                      size="small"
                                      [disabled]="!hasSelection || actionBusy"
                                      [loading]="actionBusy"
                                      (onClick)="approveSelected()">
                            </p-button>
                        </div>
                    </div>

                    <!-- ----- AKTIONS-FEHLER ----- -->
                    @if (actionError) {
                        <p-message severity="error" class="block mb-3" [text]="actionError"></p-message>
                    }

                    <!-- ----- LISTEN-ZUSTÄNDE ----- -->
                    @if (listState === 'busy') {
                        <p-skeleton height="2.5rem" styleClass="w-full mb-2"></p-skeleton>
                        <p-skeleton height="2.5rem" styleClass="w-full mb-2"></p-skeleton>
                        <p-skeleton height="2.5rem" styleClass="w-full"></p-skeleton>
                    }

                    @if (listState === 'error') {
                        <p-message severity="error" class="block" [text]="listError"></p-message>
                    }

                    @if (listState === 'ready') {
                        @if (drafts.length === 0) {
                            <div class="text-center text-600 p-4">
                                <i class="fa-regular fa-folder-open text-3xl mb-2 block"></i>
                                Keine offenen Entwürfe zur Freigabe.
                            </div>
                        } @else {
                            <p-table [value]="drafts"
                                     [(selection)]="selectedDrafts"
                                     dataKey="statementId"
                                     styleClass="p-datatable-sm"
                                     [paginator]="true"
                                     [rows]="10"
                                     [rowsPerPageOptions]="[10, 25, 50]"
                                     [showCurrentPageReport]="true"
                                     currentPageReportTemplate="{first}–{last} von {totalRecords}">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th class="w-3rem text-center">
                                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                        </th>
                                        <th>Gesellschaft</th>
                                        <th>Vermittlernummer</th>
                                        <th>Kontonummer</th>
                                        <th>Kontoauszug-Nr</th>
                                        <th>Stichtag</th>
                                        <th class="text-right">Neuer Kontostand</th>
                                        <th class="text-right">Zeilen</th>
                                        <th>Status</th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-row>
                                    <tr [class.cn-import-review__row--active]="selectedStatementId === row.statementId">
                                        <td class="text-center">
                                            <p-tableCheckbox [value]="row"></p-tableCheckbox>
                                        </td>
                                        <td>{{ row.gesellschaftName || '—' }}</td>
                                        <td>{{ row.vermittlerNr || '—' }}</td>
                                        <td>{{ row.kontoNr || '—' }}</td>
                                        <td>
                                            <a class="cn-import-review__statement-link text-primary cursor-pointer font-medium"
                                               role="button"
                                               tabindex="0"
                                               pTooltip="Kontoauszug öffnen"
                                               tooltipPosition="top"
                                               (click)="openStatement(row.statementId)"
                                               (keyup.enter)="openStatement(row.statementId)">
                                                {{ row.kontoauszugNr || '—' }}
                                            </a>
                                        </td>
                                        <td>
                                            {{ row.statementDate ? (row.statementDate | date:'dd.MM.yyyy':'':'de') : '—' }}
                                        </td>
                                        <td class="text-right">
                                            {{ (row.newBalance ?? 0) | currency:(row.currency || 'EUR'):'symbol':'1.2-2':'de' }}
                                        </td>
                                        <td class="text-right">{{ (row.lineCount ?? 0) | number:'1.0-0':'de' }}</td>
                                        <td>
                                            <p-tag severity="info" [value]="row.status || '—'"></p-tag>
                                        </td>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="9" class="text-center text-600 p-4">
                                            Keine offenen Entwürfe zur Freigabe.
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        }
                    }
                </div>
            </div>

            <!-- ===================== RECHTS: KONTOAUSZUG-DETAIL (OBC) ===================== -->
            @if (detailOpen && selectedStatementObjectIdentifier) {
                <div class="col-12 md:col-7">
                    <div class="surface-0 border-1 surface-border border-round p-3">
                        <div class="flex align-items-center justify-content-between mb-3">
                            <span class="text-lg font-medium">Kontoauszug-Detail</span>
                            <p-button icon="fa-regular fa-xmark"
                                      label="Schließen"
                                      severity="secondary"
                                      size="small"
                                      [outlined]="true"
                                      (onClick)="closeDetail()">
                            </p-button>
                        </div>

                        <!-- The embedded OBC self-loads the cn.CommissionStatement entity from this id. -->
                        <mvs-cn-commission-statement-object-component
                                [objectIdentifier]="selectedStatementObjectIdentifier">
                        </mvs-cn-commission-statement-object-component>
                    </div>
                </div>
            }

        </div>

        <!-- ===================== ABLEHNEN-DIALOG (OPTIONALER GRUND) ===================== -->
        <p-dialog [(visible)]="rejectDialogVisible"
                  header="Entwürfe ablehnen"
                  [modal]="true"
                  [closable]="!actionBusy"
                  [style]="{width: '32rem'}"
                  (onHide)="cancelReject()">

            <div class="mb-3">
                <div class="text-sm text-600 mb-2">
                    Sie lehnen {{ selectedDrafts.length | number:'1.0-0':'de' }}
                    {{ selectedDrafts.length === 1 ? 'Beleg' : 'Belege' }} ab.
                </div>
                <label class="text-sm text-600 block mb-1" for="cn-reject-reason">Grund (optional)</label>
                <textarea id="cn-reject-reason"
                          pTextarea
                          [(ngModel)]="rejectReason"
                          rows="3"
                          class="w-full"
                          placeholder="Grund der Ablehnung…">
                </textarea>
            </div>

            @if (actionError) {
                <p-message severity="error" class="block mt-2" [text]="actionError"></p-message>
            }

            <ng-template pTemplate="footer">
                <p-button label="Abbrechen"
                          icon="fa-regular fa-xmark"
                          severity="secondary"
                          [disabled]="actionBusy"
                          (onClick)="cancelReject()">
                </p-button>
                <p-button label="Ja, ablehnen"
                          icon="fa-regular fa-check"
                          severity="danger"
                          [loading]="actionBusy"
                          (onClick)="confirmReject()">
                </p-button>
            </ng-template>
        </p-dialog>

    </div>
}
